import type { BridgeConfigsResponseSchema } from '@rhinofi/bridge-api-spec'

export const findBridgeKeyForNetworkId = (networkId: string, bridgeConfig: BridgeConfigsResponseSchema) => {
  return Object.entries(bridgeConfig).find(([_, config]) => config.networkId === networkId)?.[0]
}
